export class Contratante {
  id: number;
  nombresApellidos: string;
  correoElectronico: string;
  numeroDocumento: any;

  constructor() {
    this.numeroDocumento = null;
  }
}